import React from 'react';
import {
  useField,
} from 'formik';

import FieldsSingleSelect from './FieldsSingleSelect.jsx';
import FieldsMultiSelect from './FieldsMultiSelect.jsx';
import FieldsOrdering from './FieldsOrdering.jsx';
import FieldsMatching from './FieldsMatching.jsx';

const FieldsQtnOpts = ({
  idx,
  qtnIndex: i,
  restrictEdit,
}) => {
  const [, { value }] = useField(`questionSets[${idx}].questions.${i}`);
  const { format = 'single-select' } = value;
  let Options = FieldsSingleSelect; // default format

  if (format === 'multi-select') Options = FieldsMultiSelect;
  if (format === 'ordering') Options = FieldsOrdering;
  if (format === 'matching') Options = FieldsMatching;

  return (
    <Options
      idx={idx}
      qtnIndex={i}
      restrictEdit={restrictEdit}
    />
  );
};

export default FieldsQtnOpts;
